<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M21.71 27.43L27.65 24l-5.94-3.43v6.86z"/><path d="M39 7H9a2 2 0 00-2 2v30a2 2 0 002 2h30a2 2 0 002-2V9a2 2 0 00-2-2zm-4 22.5a2.86 2.86 0 01-2 2c-1.85.5-9 .5-9 .5s-7.15 0-8.93-.48a2.86 2.86 0 01-2-2 29.57 29.57 0 01-.48-5.5 29.57 29.57 0 01.48-5.5 2.86 2.86 0 012-2C16.85 16 24 16 24 16s7.15 0 8.93.48a2.86 2.86 0 012 2 29.57 29.57 0 01.48 5.5A29.57 29.57 0 0135 29.5z"/></svg>